module.exports = __webpack_public_path__ + "static/media/ghostbusters.f75663f2.mp3";